import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from '../components/ProductCard'; // Компонент для отображения товара
import './AdminAccountPage.css'; // Importing the CSS file

const AdminAccountPage = () => {
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]); // Состояние для фильтрованных пользователей
  const [searchQuery, setSearchQuery] = useState(''); // Поле поиска
  const [currentPage, setCurrentPage] = useState(1); // Текущая страница
  const [usersPerPage] = useState(10); // Количество пользователей на странице
  const [error, setError] = useState(null);

 // Fetch users
 const fetchUsers = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get('/api/account/users', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setUsers(response.data);
    setFilteredUsers(response.data); // Изначально все пользователи
  } catch (err) {
    console.error('Ошибка при загрузке пользователей:', err.message);
    if (err.response) {
      console.log('Ответ от сервера:', err.response.data);
    }
    setError('Не удалось загрузить пользователей.');
  }
};

// Fetch products
const fetchProducts = async () => {
  try {
    const response = await axios.get('/api/products', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    setProducts(response.data);
  } catch (error) {
    console.error('Ошибка при загрузке продуктов:', error);
    setError('Не удалось загрузить список товаров.');
  }
};

// Обновление данных
const handleUpdate = () => {
  fetchProducts();
  fetchUsers();
};

// Поиск по email
const handleSearch = (event) => {
  const query = event.target.value.toLowerCase();
  setSearchQuery(query);

  // Фильтруем пользователей по email
  const filtered = users.filter((user) =>
    user.email.toLowerCase().includes(query)
  );
  setFilteredUsers(filtered);
};

// Получение пользователей для текущей страницы
const indexOfLastUser = currentPage * usersPerPage;
const indexOfFirstUser = indexOfLastUser - usersPerPage;
const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

// Переключение страниц
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

useEffect(() => {
  fetchProducts();
  fetchUsers();
}, []);

 

  // Filter products by approval status
  const approvedProducts = products.filter(product => product.isVerified); // Only approved
  const unapprovedProducts = products.filter(product => !product.isVerified); // Not approved

  return (
    <div className="admin-panel">
      <h1>Администраторская панель</h1>
      {error && <p className="error-message">Ошибка: {error}</p>}

      {/* User Section */}
      <div className="user-list">
        <h2>Список пользователей</h2>

        {/* Поле поиска */}
        <input
          type="text"
          placeholder="Поиск по email"
          value={searchQuery}
          onChange={handleSearch}
          className="search-input"
        />

        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Email</th>
              <th>Баланс</th>
              <th>Роль</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.balance}</td>
                <td>{user.role}</td>
                <td>
                  <button
                    onClick={async () => {
                      const newBalance = prompt(
                        `Введите новый баланс для пользователя ${user.name}:`,
                        user.balance
                      );
                      if (newBalance !== null && !isNaN(newBalance)) {
                        try {
                          await axios.put(
                            `/api/account/users/${user.id}/balance`,
                            { balance: newBalance },
                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem('token')}`,
                              },
                            }
                          );
                          alert('Баланс успешно обновлён!');
                          handleUpdate();
                        } catch (err) {
                          console.error('Ошибка обновления баланса:', err);
                          alert('Не удалось обновить баланс.');
                        }
                      } else {
                        alert('Введите корректное число.');
                      }
                    }}
                  >
                    Обновить баланс
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Пагинация */}
        <div className="pagination">
          {Array.from({ length: Math.ceil(filteredUsers.length / usersPerPage) }).map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>

      {/* Product Section */}
      <div className="product-list">
        <h2>Анкеты</h2>

        {/* Unapproved Products */}
        <div className="product-section">
          <h3 className="product-section_H3">Не одобренные анкет</h3>
          {unapprovedProducts.length > 0 ? (
            unapprovedProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onUpdate={handleUpdate}
                isAdmin={true}
              />
            ))
          ) : (
            <p>Нет не одобренных анкет</p>
          )}
        </div>
        {/* Approved Products */}
        <div className="product-section">
          <h3 className="product-section_H3">Одобренные анкеты</h3>
          {approvedProducts.length > 0 ? (
            approvedProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onUpdate={handleUpdate}
                isAdmin={true}
              />
            ))
          ) : (
            <p>Нет одобренных анкет</p>
          )}
        </div>


      </div>
    </div>
  );
};

export default AdminAccountPage;
